import {Component, Inject, OnInit} from '@angular/core';
import {LegalEntity} from '../model/legal-entity.model';
import {FormControl, Validators} from '@angular/forms';
import {CustomerEmailService} from '../../core/services/customer-email.service';
import {EventBusService} from '../../core/services/event-bus.service';
import {DictionaryPosition} from '../model/dictionary.model';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-add-customer-email',
  templateUrl: './add-customer-email.component.html',
  styleUrls: ['./add-customer-email.component.css']
})
export class AddCustomerEmailComponent implements OnInit {
  legalEntity: LegalEntity;
  emailForm: FormControl;

  constructor(private customerEmailService: CustomerEmailService,
              private eventBusService: EventBusService,
              private dialogRef: MatDialogRef<AddCustomerEmailComponent>,
              @Inject(MAT_DIALOG_DATA) data) {
    this.legalEntity = data;
    this.createForm();
  }

  ngOnInit(): void {
  }

  addEmail() {
    return this.customerEmailService.create(this.legalEntity.id, this.emailForm.value)
      .subscribe((email) => {
        this.eventBusService.display(DictionaryPosition.OK);
        this.legalEntity.emails.data.push(email);
        this.emailForm.reset();
        this.dialogRef.close();
      });
  }

  private createForm() {
    this.emailForm = new FormControl(null, Validators.email);
  }
}
